export default __webpack_public_path__ + "static/media/2.seguridad-y-salud-ocupacional.2c330371.png";